<template>
    <div>
        <app-navigation/>
        <app-banner
          backgroundUrl="/press/media-header.jpeg"
          :headerButtons="headerButtons"
          backgroundSize="cover"
          title="EPIWATCH® in the Media"
          description="Explore our media coverage and press releases, featuring the latest news about EPIWATCH® across radio interviews, article, and publications"
        />
        <div>
          <div :class="mobile ? 'white-section-mobile' : 'white-section'" style="width: 100%; max-width: 1500px; margin: 0 auto; height: 100%; padding:5%">
            <div :class="mobile ? 'section-title-mobile' : 'section-title'" id="Press">Media</div>
            <div class="card-grid">
              <div
              :v-if="!loading"
              v-for="(item, index) in media.slice(0, visibleCount)"
              :key="index"
              class="card"
              
              >
                <component
                  :is="isExternal(item.link) ? 'a' : 'router-link'"
                  :href="isExternal(item.link) ? item.link : null"
                  :to="!isExternal(item.link) ? item.link : null"
                  :target="isExternal(item.link) ? '_blank' : null"
                  rel="noopener noreferrer"
                  style="text-decoration: none;"
                >

                  <div>
                    <img :src="item.logo" alt="logo" class="card-logo" />
                    <h2 class="card-title">{{ item.title }}</h2>
                    <p class="card-date">{{ item.date }}</p>
                  </div>
                </component>
              </div>
            </div>
            <div class="show-more-container" v-if="media.length > visibleCount">
              <button @click="showMore" class="show-more-button">
                Show next
              </button>
            </div>
          </div>
          <div class="media-blue">
            <div class="divider">
              <span>Social</span>
            </div>
            <div style="max-width: 1500px; margin: auto;">
              <div class="social-feature">
                <h2 class="social-feature-title">Amcham Chairman's Award Acceptance Speech</h2>
                <div class="social-video-container">
                  <video class="social-video" controls preload="metadata">
                    <source src="/media/Amcham_Vid.mp4" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
              <div class="grid-container">
                <div ref="tweetContainer" class="tweet-container" v-html="tweetHtml"></div>
                <div ref="tweetContainer" class="tweet-container" v-html="tweetHtml2"></div>
                <div ref="tweetContainer" class="tweet-container" v-html="tweetHtml3"></div>

              </div>
            </div>
          </div>
        </div>
        <app-footer/>
    </div>
</template>

<script>
// @ is an alias to /src
import AppNavigation from '@/components/AppNavigation.vue'
import AppFooter from '@/components/AppFooter.vue'
import AppBanner from '@/components/AppBanner.vue'
import axios from 'axios'

export default {
  name: 'Media',
  components: {
      AppNavigation,
      AppFooter,
      AppBanner,
  },
  data: () => ({
    mobile: null,
    windowWidth: null,
    headerButtons: [],
    videoCarousel: 0,
    visibleCount: 6,
    videos: [
      {url: "https://www.youtube.com/embed/u9JEuL6mCcw", des: "Introduction to Epiwatch"},
      {url: "https://www.youtube.com/embed/KH4Qulb8Tok", des: "EPIWATCH Launches Hindi Version"},
      {url: "https://www.youtube.com/embed/CpL6HxUYDC8", des: "Professor Raina MacIntyre on a panel at The Brookings Institute Panel on biosafety and COVID-19 origins."}
    ],
    media: [],
    embedHtml: "https://twitter.com/EPIWATCH_bsp/status/1961225378196049954",
    loading: true,
    tweetHtml: `
        <blockquote class="twitter-tweet"><p lang="en" dir="ltr">(14 Oct - 20 Oct) The EPIWATCH team reviews global outbreaks daily and provides a weekly summary. This  week, a case of #Hantavirus was recorded in a 40-year-old woman from the community of #Montero, #Panama; &amp; #France has reported the 1st documented human case of the #Shamonda #virus.</p>&mdash; EPIWATCH (@EPIWATCH_bsp) <a href="https://x.com/EPIWATCH_bsp/status/2113383181227626746?ref_src=twsrc%5Etfw">October 22, 2026</a></blockquote>`,
    tweetHtml2: `<blockquote class="twitter-tweet"><p lang="en" dir="ltr">#France has reported the first documented human case of the #Shamonda #virus, which was previously detected only in animals. The patient was immunocompromised.

https://t.co/URYzjpoCnR</p>&mdash; EPIWATCH (@EPIWATCH_bsp) <a href="https://x.com/EPIWATCH_bsp/status/2113382491096772911?ref_src=twsrc%5Etfw">October 22, 2026</a></blockquote>`,
    tweetHtml3: `<blockquote class="twitter-tweet"><p lang="en" dir="ltr">#Nigeria has confirmed an #Ebola case in its capital, #Abuja, after a woman who arrived from #Uganda tested positive for the virus.

https://t.co/BwcgANHBdG</p>&mdash; EPIWATCH (@EPIWATCH_bsp) <a href="https://x.com/EPIWATCH_bsp/status/2113131240895447057?ref_src=twsrc%5Etfw">October 22, 2026</a></blockquote>`,
    
  }),
  created() {
      window.addEventListener('resize', this.checkScreen);
      this.checkScreen();
    },
    destroy() {
      window.removeEventListener('resize', this.checkScreen)
    },
    async mounted() {
      await this.fetch_media();
      try {
        const res = await axios.get(
          `http://api.epiwatch.app/api/v2/twitter/posts`
        );


        const embedHtml = res.data[0].embed.replace(
          /<script[^>]*>[\s\S]*?<\/script>/gi,
          ""
        );

        const embedHtml2 = res.data[1].embed.replace(
          /<script[^>]*>[\s\S]*?<\/script>/gi,
          ""
        );
        const embedHtml3 = res.data[2].embed.replace(
          /<script[^>]*>[\s\S]*?<\/script>/gi,
          ""
        );

        this.tweetHtml = embedHtml;
        this.tweetHtml2 = embedHtml2;
        this.tweetHtml3 = embedHtml3;


        this.$nextTick(() => {
          if (window.twttr && window.twttr.widgets) {
            window.twttr.widgets.load();
          }
        });
      } catch (err) {
        console.error("Error loading tweet embed:", err);
      }
      this.$nextTick(() => {
        if (window.twttr?.widgets?.load) {
          window.twttr.widgets.load();
        }
      });
      this.checkScreen();
      this.fetch_media().then(() => {
        this.loading = false
      })
      this.loadTwitterWidgets();
    },
    methods: {
      isExternal(link) {
        return /^https?:\/\//.test(link)
      },
      checkScreen() {
        this.windowWidth = window.innerWidth;
        if (this.windowWidth <= 1000) {
          this.mobile = true;
        } else {
          this.mobile = false;
        }
        return;
      },
      async fetch_media() {
        const response = await axios.get("data/media.json");
        this.media = response.data;
      },
      showMore() {
        this.visibleCount += 6;
      },
      loadTwitterWidgets() {
      return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = "https://platform.twitter.com/widgets.js";
        script.async = true;
        script.onload = resolve;
        document.body.appendChild(script);
        
      });
    }
    },
  
}
</script>

<style>
.grid-container {
  column-count: 3;
  column-gap: 1rem;
}
@media (max-width:600px) {
  .grid-container {
    column-count: 1;
  }
}

.tweet-box {
  height: 400px;
  overflow-y: auto;
}


.v-btn__content {
  width: 100%;
  white-space: normal;
}

a {
  text-decoration: none;
}

.social-video-container {
  margin-bottom: 24px;
}

.social-feature {
  border: 1px solid #e0e0e0;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 12px;
  margin: 0 auto 24px;
  padding: 12px 24px;
  width: 90%;
}

.social-feature-title {
  color: #333;
  font-family: Roberto, Avenir Next;
  font-size: 1.25em;
  font-weight: 600;
  margin: 0 0 12px;
  text-align: center;
}

.social-video {
  border-radius: 12px;
  display: block;
  max-width: 100%;
  width: 100%;
}
</style>